import ProductCatalogue from './ProductCatalogue'

export default ProductCatalogue
